import { render, staticRenderFns } from "./DefaultModal.vue?vue&type=template&id=5baad949&scoped=true&"
import script from "./DefaultModal.vue?vue&type=script&lang=js&"
export * from "./DefaultModal.vue?vue&type=script&lang=js&"
import style0 from "./DefaultModal.vue?vue&type=style&index=0&id=5baad949&prod&lang=scss&"
import style1 from "./DefaultModal.vue?vue&type=style&index=1&id=5baad949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baad949",
  null
  
)

export default component.exports